/**
 * Coerce any Axios/Fetch error into a string safe to render as a React child.
 *
 * Two array shapes appear in this app:
 *   1. FastAPI native 422: [{ type, loc: ['body','field'], msg, input, ctx }, ...]
 *   2. Our validate_batch:  [{ field, code, message }, ...]
 * Putting either array into <div>{error}</div> crashes React with
 * "Objects are not valid as a React child."
 */
export function extractApiError(err: any, fallback = 'Something went wrong'): string {
  if (!err) return fallback;
  if (typeof err === 'string') return err;

  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((d: any) => {
        if (typeof d === 'string') return d;
        // validate_batch shape uses `field`/`message`; FastAPI native uses `loc`/`msg`.
        const field = d?.field
          ?? (Array.isArray(d?.loc) ? d.loc.filter((p: any) => p !== 'body').join('.') : '');
        const msg = d?.message || d?.msg || 'Invalid';
        return field ? `${field}: ${msg}` : msg;
      })
      .join('; ');
  }

  if (detail && typeof detail === 'object') {
    return JSON.stringify(detail);
  }

  return err?.message || fallback;
}

export default extractApiError;
